import * as React from "react"

export default function CardsLoading({numberOfCards = 3}) {
    return <div className="loadingCards" style={{ height: '95px'}}>
        {Array.from({ length: numberOfCards }).map((_, idx)=><div key={idx}></div>)}
	</div>
}